export function formatTaskDate(value) {
    if (!value) {
        return "-";
    }

    const numericValue = Number(value);
    const normalizedValue = Number.isNaN(numericValue)
        ? value
        : numericValue < 100000000000 ? numericValue * 1000 : numericValue;
    const date = new Date(normalizedValue);

    if (Number.isNaN(date.getTime())) {
        return "-";
    }

    return date.toLocaleString();
}

export function getTaskType(task) {
    if (task?.taskType) {
        return task.taskType;
    }

    if (task?.type && task?.source === "local") {
        return task.type;
    }

    return Number(task?.realTime) === 1 ? "Analysis" : "Validation";
}

export function getTaskTitle(task) {
    return task?.title || task?.rule || task?.details || "Processing task";
}

export function getTaskGroupKey(task) {
    return [
        task?.source || "server",
        task?.device || task?.target || "",
        task?.msb || "",
        task?.realTime ?? "",
        getTaskType(task),
        getTaskTitle(task)
    ].map(value => String(value).toLowerCase()).join("|");
}

export function getTaskStartTime(task) {
    return [
        task?.startTime,
        task?.startedAt,
        task?.startDate,
        task?.createdAt,
        task?.createdDate
    ].find(value => value !== null && value !== undefined && value !== "");
}

export function hasTaskStartTime(task) {
    return getTaskStartTime(task) !== undefined;
}

export function isValidProcessingTask(task) {
    if (!task || typeof task !== "object" || task.id === undefined || task.id === null || task.id === "") {
        return false;
    }

    if (!hasTaskStartTime(task)) {
        return false;
    }

    const title = String(task?.title || task?.rule || task?.details || "").trim().toLowerCase();
    return title !== "" && title !== "undefined" && title !== "null";
}

export function isProcessingTask(task) {
    return String(task?.status || "").toUpperCase() === "PROCESSING";
}

export function isCompleteTask(task) {
    const status = String(task?.status || "").toUpperCase();
    return status !== "" && status !== "PROCESSING";
}

export function getTaskStatus(task) {
    if (isProcessingTask(task)) {
        return "Processing";
    }

    if (isCompleteTask(task)) {
        return "Complete";
    }

    if (String(task?.status || "").toUpperCase() === "ERROR") {
        return "";
    }

    const status = String(task?.status || "PROCESSING").toLowerCase();
    return status.charAt(0).toUpperCase() + status.slice(1);
}

export function mergeRefreshedTasks(currentTasks, refreshedTasks) {
    const uniqueRefreshedTasks = [];
    const seenRefreshedTasks = new Set();

    refreshedTasks.filter(isValidProcessingTask).forEach(task => {
        const key = task?.id || getTaskGroupKey(task);
        if (seenRefreshedTasks.has(key)) {
            return;
        }

        seenRefreshedTasks.add(key);
        uniqueRefreshedTasks.push(task);
    });

    const refreshedIds = new Set(uniqueRefreshedTasks.map(task => task.id).filter(Boolean));
    const refreshedGroups = new Set(uniqueRefreshedTasks.map(getTaskGroupKey));
    const inferredCompletedTasks = currentTasks
        .filter(isValidProcessingTask)
        .filter(task => {
            if (refreshedIds.has(task.id) || refreshedGroups.has(getTaskGroupKey(task))) {
                return false;
            }

            return isProcessingTask(task) || (
                task?.inferredCompleted === true &&
                Date.now() - Number(task.completedTime || 0) < 10 * 60 * 1000
            );
        })
        .map(task => ({
            ...task,
            status: "COMPLETE",
            completedTime: task.completedTime || Date.now(),
            inferredCompleted: true
        }));

    return [...uniqueRefreshedTasks, ...inferredCompletedTasks];
}
